import { onMounted, onUnmounted, readonly, ref } from "vue"

// TODO refactor to @vueuse/core shared composable using effect scope 
let hasInitialized = false
const scrollY = ref(0)
const listeners = new Set<() => void>()

let ticking = false

const handleScroll = () => {
    if (typeof window === "undefined") return
    if (!ticking) {
        window.requestAnimationFrame(() => {
            scrollY.value = window.scrollY
            listeners.forEach(callback => callback())
            ticking = false
        })
        ticking = true
    }
}

export function useScroll() {
    if (!hasInitialized) {
        onMounted(() => {
            window.addEventListener("scroll", handleScroll, { passive: true })
            hasInitialized = true
        })
    }

    const cleanup = () => {
        if (typeof window !== "undefined" && hasInitialized && listeners.size === 0) {
            window.removeEventListener("scroll", handleScroll)
            hasInitialized = false
        }
    }

    const registerCallback = (callback: () => void) => {
        listeners.add(callback)
    
        return () => {
            listeners.delete(callback)
            if (listeners.size === 0) {
                cleanup()
            }
        }
    }

    return {
        scrollY: readonly(scrollY),
        registerCallback
    }
}

export function useScrolled(pixels = 50) {
    const { scrollY } = useScroll()
    const scrolled = ref(false)
  
    const checkScroll = () => {
        scrolled.value = scrollY.value > pixels
    }
  
    checkScroll()
  
    const unregister = useScroll().registerCallback(checkScroll)
  
    onUnmounted(() => {
        unregister()
    })
  
    return scrolled
}

/**
 * Scrolls to an element by ID and focuses it after scroll completes.
 * Per WCAG Technique G1: activating an in-page link must move keyboard focus to the target.
 * @param elementId - The ID of the element to scroll to and focus (with or without leading #)
 * @param delay - Optional delay in ms before focusing (default 250ms to allow scroll animation)
 */
export function scrollToAndFocus(elementId: string, delay = 250): void {
    const id = elementId.startsWith("#") ? elementId.slice(1) : elementId
    const target = document.getElementById(id)
    if (!target) return
    
    target.scrollIntoView({ behavior: "smooth" })
    
    setTimeout(() => {
        target.focus({ preventScroll: true })
    }, delay)
} 